import { FontsEnum } from 'core/constants/enums/FontsEnum.ts';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';

export const subscriptionPlansStyles = {
	subscriptionComp: {
		width: '100%',

		display: 'flex',
		flexDirection: 'column',
		gap: { xs: '24px', sm: '32px' },
	},

	planTypeTabBadge: {
		padding: '2px 12px',
		borderRadius: '2px',
		width: '100%',
		backgroundColor: 'colors.purple4',
	},

	subscriptionPlansSection: {
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'row' },
		gap: '16px',
	},
	subtext: {
		...reusableStyles.flexColWithGap(8),
		width: '100%',
		alignItems: 'flex-start',
	},
	termsConditions: {
		fontSize: '12px !important',
		fontFamily: FontsEnum.INTER,
		fontWeight: 500,
		lineHeight: '20px',
	},
	processManageSubscription: (isLoading) => ({
		top: 0,
		left: 0,
		position: 'absolute',
		display: isLoading ? 'flex' : 'none',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'colors.loadingBackground',
		width: '100%',
		height: '100%',
		'& svg': {
			maxWidth: '150px',
			maxHeight: '150px',
		},
		'&>div': {
			justifyContent: 'center',
		},
	}),
};
